import(/* webpackMode: "eager" */ "/vercel/path0/app/ai-analytics/page.tsx");
